// @flow
import React from 'react';
import accounting from 'accounting';
import styled from 'styled-components';
import * as RenterApp from 'styles/Home/StyledRenterApplication';

const StyledNumberInput = styled.input`
  display: block;
  width: 100%;
  min-width: 110px;
  height: 35px;
  padding: 0 40px 0 30px;
  border: 1px solid #ececec;
  border-radius: 2px;
  background-color: white;
  line-height: 35px;
  font-size: 14px;
  text-align: ${props => (props.textAlign ? props.textAlign : 'end')};
  color: ${({ textColor }) => textColor || '#4a4a4a'};
  z-index: 1;

  &:disabled {
    background-color: #ececec;
    color: #9b9b9b;
  }
`;

const Currency = styled.span`
  position: absolute;
  top: 0;
  right: 10px;
  height: 35px;
  color: #9b9b9b;
  font-size: 14px;
  line-height: 35px;
  z-index: 0;
`;

const CurrencySign = styled.span`
  position: absolute;
  top: 0;
  left: 10px;
  height: 35px;
  color: #9b9b9b;
  font-size: 14px;
  line-height: 35px;
  z-index: 0;
`;

const ErrorMessage = styled.span.attrs({
  className: 'error-message'
})`
  color: red;
  position: ${props => props.position};
  top: ${props => props.top};
  font-size: 14px;
`;

type PropsType = {
  textColor?: string,
  textAlign?: string,
  currency: string,
  currencySign: string,
  name: string,
  value: number,
  isValidated?: boolean,
  onValueChange: (value: number, input: string) => void,
  placeholder?: string,
  readonly?: boolean,
  disabled?: boolean,
  formatted?: boolean,
  errorMessagePosition?: string,
  errorMessageTop?: string,
  inputStyle?: any,
  schema?: any
};

type StateType = {
  error: string,
  touched: boolean,
  inputValue: number,
  displayValue: string
};

export default class MoneyInputComponent extends React.Component<
  PropsType,
  StateType
> {
  static defaultProps = {
    formatted: true,
    errorMessagePosition: 'absolute',
    errorMessageTop: '35px',
    placeholder: '0'
  };

  constructor(props: PropsType) {
    super(props);

    this.state = {
      error: '',
      touched: false,
      inputValue: this.props.value ? this.props.value : 0,
      displayValue: ''
    };
  }

  handleChange = ({ target }: Event<HTMLInputElement>): void => {
    let inputValue = target.value.replace(/[^\d.]/g, '');
    this.setState({ inputValue });
    this.validationSchema(inputValue);
  };

  handleBlur = () => {
    this.validationSchema(this.state.inputValue);
    if (!this.state.touched) {
      this.setState({
        touched: true
      });
    }
  };

  validationSchema = (inputValue: any): void => {
    const { name } = this.props;
    if (this.props.schema) {
      this.props.schema
        .validate({ inputValue: inputValue })
        .then(() => {
          this.props.onValueChange &&
            this.props.onValueChange(inputValue, name);
          this.setStateError('');
        })
        .catch(e => {
          this.props.onValueChange &&
            this.props.onValueChange(inputValue, name);
          this.setStateError(e.message);
        });
    } else {
      this.props.onValueChange && this.props.onValueChange(inputValue, name);
    }
  };

  setStateError = (error: string): void => {
    this.setState({ error });
  };

  static getDerivedStateFromProps(props: PropsType, state: StateType) {
    const value = props.value ? props.value : 0;
    state.inputValue = value;
    if (props.formatted) {
      state.displayValue = value > 0 ? accounting.formatNumber(value) : '';
    } else {
      state.displayValue = value > 0 ? value : '';
    }
    return state;
  }

  render() {
    const { error, touched, displayValue } = this.state;

    const {
      currency,
      currencySign,
      name,
      textAlign,
      textColor,
      placeholder = '',
      readonly = false,
      disabled = false,
      errorMessagePosition,
      errorMessageTop,
      inputStyle = {}
    } = this.props;
    return (
      <RenterApp.StyledValidatedInput>
        <StyledNumberInput
          textAlign={textAlign}
          textColor={textColor}
          type="text"
          value={displayValue}
          name={name}
          placeholder={placeholder}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          readOnly={readonly}
          disabled={disabled}
          style={inputStyle}
        />
        <Currency>{currency}</Currency>
        <CurrencySign>{currencySign}</CurrencySign>
        {error && touched && (
          <ErrorMessage position={errorMessagePosition} top={errorMessageTop}>
            {error}
          </ErrorMessage>
        )}
      </RenterApp.StyledValidatedInput>
    );
  }
}
